import { render, staticRenderFns } from "./ConsentScreen.vue?vue&type=template&id=53597c66"
import script from "./ConsentScreen.vue?vue&type=script&lang=ts"
export * from "./ConsentScreen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports